import { render, staticRenderFns } from "./SalesReportQueryMetaInputs.vue?vue&type=template&id=2c20aaa3&"
import script from "./SalesReportQueryMetaInputs.vue?vue&type=script&lang=ts&"
export * from "./SalesReportQueryMetaInputs.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports